import { inClass } from "../../../../../utils/Helpers";
import type { BuilderDnDReorderGate } from "../../../../../store/reducers/builderReducers/structure/structureReorderPlan";
import {
  isColumnReorderLayoutParent,
  resolveColumnReorderLayoutParent,
} from "./columnReorderLayoutParent";

export const handleDragOverPos = (
  e,
  ref,
  isText,
  gate?: BuilderDnDReorderGate
) => {
  const builderElement = inClass("builder-component--active", ref.current);
  e.preventDefault();

  if (isText) {
    return;
  }

  const canonicalTarget = inClass("builder-component", e.target);
  let targetElement = canonicalTarget || e.target;
  const rect = targetElement.getBoundingClientRect();

  // Get the bounding rectangle of the target element

  ////////////////////
  // TODO: NEEDS REFACTOR

  // The top, middle, and bottom positions as percentages (drop locations)
  // Can be adjusted to change the drop position (33.3, 33.3, 33.3) might work also.
  // NB! For some elements, these values are changed in corresponding if block
  const middlePosition = 0.25 * rect.height; // 25% down from the top
  const bottomPosition = 0.75 * rect.height; // 75% down from the top

  // Get the current Y position of the mouse pointer relative to the target element
  const mouseY = e.clientY - rect.top;

  if (!builderElement) {
    return;
  }

  const previewAllowed = (
    parent_id: string | number,
    section: boolean,
    position: string
  ) => {
    if (!gate) {
      return true;
    }
    return gate.isAllowed({
      parent_id,
      draggedComponentId: builderElement.id,
      destinationId: targetElement.id,
      position,
      section,
    });
  };

  // 1) If component is a section
  if (builderElement.getAttribute("data-component-type") === "section") {
    if (builderElement.getAttribute("data-drag-type") === "main") {
      // Dragging a section element, that is top-level parent element
      // Need to check if the target is a section && is also top-level parent element

      if (
        targetElement.getAttribute("data-component-type") === "section" &&
        targetElement.offsetParent &&
        !targetElement.offsetParent.classList.contains("builder-component")
      ) {
        if (mouseY < middlePosition) {
          // Set the position to the builderElement

          targetElement.style.webkitBoxShadow =
            "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.mozBoxShadow = "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.boxShadow = "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.transition = `box-shadow 200ms ease-in-out`;

          builderElement?.setAttribute("data-position", "top");
          // e.target.style.borderBottom = `0px solid blue`;
        } else if (mouseY >= middlePosition && mouseY < bottomPosition) {
          targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 0px #00d9ff";
          targetElement.style.mozBoxShadow = "inset 0px 0px 0px 0px #00d9ff";
          targetElement.style.boxShadow = "inset 0px 0px 0px 0px #00d9ff";
          targetElement.style.transition = `none`;

          // Set the position to the builderElement
          builderElement?.setAttribute("data-position", "middle");
        } else {
          targetElement.style.webkitBoxShadow =
            "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.mozBoxShadow = "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.boxShadow = "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.transition = `box-shadow 200ms ease-in-out`;

          // Set the position to the builderElement
          builderElement?.setAttribute("data-position", "bottom");
        }

        return;

        // Dragging a section element, that is top-level parent element
        // Need to check if the target is a section && is also top-level parent element
      }
    } else if (
      builderElement?.getAttribute("data-drag-type") !== "main" &&
      builderElement.getAttribute("data-component-type") !== "inner-section"
    ) {
      const columnDropLayoutParent = resolveColumnReorderLayoutParent(
        targetElement.offsetParent as HTMLElement | null
      );
      if (
        targetElement.getAttribute("data-component-type") === "section" &&
        columnDropLayoutParent != null &&
        isColumnReorderLayoutParent(columnDropLayoutParent) &&
        builderElement.id !== targetElement.id &&
        columnDropLayoutParent.offsetParent?.id !== builderElement.id
      ) {
        const bottomPosition = 0.5 * rect.height; // 25% down from the top

        // Get the current Y position of the mouse pointer relative to the target element
        const mouseY = e.clientY - rect.top;

        if (
          !previewAllowed(
            gate?.structureOrderParent ?? 0,
            true,
            mouseY < bottomPosition ? "top" : "bottom"
          )
        ) {
          return;
        }

        if (mouseY < bottomPosition) {
          // Set the position to the builderElement

          targetElement.style.webkitBoxShadow =
            "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.mozBoxShadow = "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.boxShadow = "inset 0px 10px 0px -2px #00d9ff";
          targetElement.style.transition = `box-shadow 200ms ease-in-out`;

          builderElement?.setAttribute("data-position", "top");
        } else {
          targetElement.style.webkitBoxShadow =
            "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.mozBoxShadow = "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.boxShadow = "inset 0px -10px 0px -2px #00d9ff";
          targetElement.style.transition = `box-shadow 200ms ease-in-out`;

          builderElement?.setAttribute("data-position", "bottom");
        }

        return;
      } else if (
        targetElement.getAttribute("data-component-type") === "section" &&
        targetElement.classList.contains("builder-component") &&
        targetElement.classList.contains("row") &&
        !targetElement.offsetParent.classList.contains("builder-component") &&
        !builderElement.offsetParent?.classList.contains("col") &&
        !targetElement.offsetParent.classList.contains("inner-section") &&
        builderElement?.offsetParent?.id !== targetElement.id &&
        builderElement.id !== targetElement.id &&
        builderElement.getAttribute("data-component-type") !== "inner-section"
      ) {
        if (!previewAllowed(gate?.structureOrderParent ?? 0, true, "middle")) {
          return;
        }
        targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        // Set the position to the builderElement
        builderElement?.setAttribute("data-position", "middle");

        return;
      } else if (
        targetElement.getAttribute("data-component-type") === "inner-section" &&
        targetElement.classList.contains("builder-component") &&
        targetElement.offsetParent.classList.contains("col") &&
        builderElement?.offsetParent?.id !== targetElement.id &&
        builderElement.id !== targetElement.id
      ) {
        if (!previewAllowed(gate?.structureOrderParent ?? 0, true, "middle")) {
          return;
        }
        targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        // Set the position to the builderElement
        builderElement?.setAttribute("data-position", "middle");
      } else if (
        targetElement.getAttribute("data-component-type") === "footer" &&
        targetElement.classList.contains("builder-component") &&
        !targetElement.offsetParent.classList.contains("builder-component") &&
        !builderElement.offsetParent?.classList.contains("col") &&
        !targetElement.offsetParent.classList.contains("inner-section") &&
        builderElement?.offsetParent?.id !== targetElement.id &&
        builderElement.id !== targetElement.id &&
        builderElement.getAttribute("data-component-type") !== "inner-section"
      ) {
        if (!previewAllowed(gate?.structureOrderParent ?? 0, true, "middle")) {
          return;
        }
        targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        // Set the position to the builderElement
        builderElement?.setAttribute("data-position", "middle");
      }
    }
  }

  if (builderElement?.getAttribute("data-component-type") === "nav-item") {
    if (targetElement.getAttribute("data-component-type") === "nav") {
      if (!previewAllowed(gate?.genericOrderParent ?? 0, false, "middle")) {
        return;
      }
      targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.transition = `box-shadow 200ms ease-in-out`;

      builderElement?.setAttribute("data-position", "middle");
    } else if (
      targetElement.getAttribute("data-component-type") === "nav-item"
    ) {
      const topPosition = 0; // Not needed (always 0)
      const bottomPosition = 0.5 * rect.height; // 25% down from the top

      // Get the current Y position of the mouse pointer relative to the target element
      const mouseY = e.clientY - rect.top;

      if (
        !previewAllowed(
          gate?.genericOrderParent ?? 0,
          false,
          mouseY < bottomPosition ? "top" : "bottom"
        )
      ) {
        return;
      }

      if (mouseY < bottomPosition) {
        // Set the position to the builderElement

        targetElement.style.webkitBoxShadow = "inset 0px 7px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 7px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 7px 0px -2px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        builderElement?.setAttribute("data-position", "top");
      } else {
        targetElement.style.webkitBoxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        builderElement?.setAttribute("data-position", "bottom");
      }
    }
  }

  if (builderElement?.getAttribute("data-component-type") === "inner-section") {
    if (
      targetElement.getAttribute("data-component-type") === "section" &&
      targetElement.offsetParent?.classList.contains("builder-component") &&
      !targetElement.offsetParent?.classList.contains("inner-section") &&
      targetElement !== builderElement.offsetParent
    ) {
      if (!previewAllowed(gate?.structureOrderParent ?? 0, false, "middle")) {
        return;
      }
      targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.transition = `box-shadow 200ms ease-in-out`;

      builderElement?.setAttribute("data-position", "middle");
    } else if (
      targetElement.offsetParent?.classList.contains("builder-component") &&
      !targetElement.offsetParent?.classList.contains("inner-section") &&
      targetElement.offsetParent?.classList.contains("col") &&
      !targetElement.offsetParent?.offsetParent?.classList.contains("inner-section")
    ) {
      const bottomPosition = 0.5 * rect.height; // 25% down from the top

      // Get the current Y position of the mouse pointer relative to the target element
      const mouseY = e.clientY - rect.top;

      if (
        !previewAllowed(
          gate?.genericOrderParent ?? 0,
          false,
          mouseY < bottomPosition ? "top" : "bottom"
        )
      ) {
        return;
      }

      if (mouseY < bottomPosition) {
        // Set the position to the builderElement

        targetElement.style.webkitBoxShadow = "inset 0px 10px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 10px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 10px 0px -2px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        builderElement?.setAttribute("data-position", "top");
      } else {
        targetElement.style.webkitBoxShadow =
          "inset 0px -10px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px -10px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px -10px 0px -2px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        builderElement?.setAttribute("data-position", "bottom");
      }
    }
  }

  // If component we are dragging is not a section
  if (
    builderElement?.getAttribute("data-component-type") !== "section" &&
    builderElement?.getAttribute("data-component-type") !== "inner-section" &&
    builderElement?.getAttribute("data-component-type") !== "nav-item"
  ) {
    if (
      targetElement.getAttribute("data-component-type") === "section" &&
      targetElement.offsetParent.classList.contains("builder-component")
    ) {
      if (!previewAllowed(gate?.genericOrderParent ?? 0, false, "middle")) {
        return;
      }
      targetElement.style.webkitBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.mozBoxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.boxShadow = "inset 0px 0px 0px 8px #00d9ff";
      targetElement.style.transition = `box-shadow 200ms ease-in-out`;

      builderElement?.setAttribute("data-position", "middle");
    } else if (
      targetElement.getAttribute("data-component-type") !== "section" &&
      targetElement.offsetParent?.classList.contains("builder-component") &&
      !targetElement.classList.contains("global-editor") &&
      targetElement.offsetParent.id !== builderElement.id &&
      targetElement.id !== builderElement.id
    ) {
      // The top, middle, and bottom positions as percentages (drop locations)
      // Can be adjusted to change the drop position (33.3, 33.3, 33.3) might work also.
      const bottomPosition = 0.5 * rect.height; // 25% down from the top
      // const bottomPosition = 0.75 * rect.height; // 75% down from the top

      // Get the current Y position of the mouse pointer relative to the target element
      const mouseY = e.clientY - rect.top;

      if (
        !previewAllowed(
          gate?.genericOrderParent ?? 0,
          false,
          mouseY < bottomPosition ? "top" : "bottom"
        )
      ) {
        return;
      }

      if (mouseY < bottomPosition) {
        // Set the position to the builderElement

        targetElement.style.webkitBoxShadow = "inset 0px 7px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px 7px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px 7px 0px -2px #00d9ff";

        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        if (
          targetElement.getAttribute("data-component-type") === "image" &&
          targetElement.firstChild &&
          targetElement.firstChild.classList.contains("builder-image--loaded")
        ) {
          targetElement.firstChild.style.webkitBoxShadow =
            "inset 0px 7px 0px -2px #00d9ff";
          targetElement.firstChild.style.mozBoxShadow =
            "inset 0px 7px 0px -2px #00d9ff";
          targetElement.firstChild.style.boxShadow =
            "inset 0px 7px 0px -2px #00d9ff";

          targetElement.firstChild.style.transition = `box-shadow 200ms ease-in-out`;
        }

        builderElement?.setAttribute("data-position", "top");

        // e.target.style.borderBottom = `0px solid blue`;
      } else {
        targetElement.style.webkitBoxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.mozBoxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.boxShadow = "inset 0px -7px 0px -2px #00d9ff";
        targetElement.style.transition = `box-shadow 200ms ease-in-out`;

        if (
          targetElement.getAttribute("data-component-type") === "image" &&
          targetElement.firstChild &&
          targetElement.firstChild.classList.contains("builder-image--loaded")
        ) {
          targetElement.firstChild.style.webkitBoxShadow =
            "inset 0px -7px 0px -2px #00d9ff";
          targetElement.firstChild.style.mozBoxShadow =
            "inset 0px -7px 0px -2px #00d9ff";
          targetElement.firstChild.style.boxShadow =
            "inset 0px -7px 0px -2px #00d9ff";

          targetElement.firstChild.style.transition = `box-shadow 200ms ease-in-out`;
        }

        // Set the position to the builderElement
        builderElement?.setAttribute("data-position", "bottom");
      }

      return;
    }
  }
};
